var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681 4624 c-169 -45 -301 -180 -346 -351 -23 -87 -22 -2540 0 -2628 45 -172 179 -305 352 -350 48 -13 184 -15 885 -15 l828 0 0 -240 0 -239 -429 -3 c-416 -3 -430 -4 -457 -24 -53 -39 -69 -71 -69 -134 0 -63 16 -95 69 -134 27 -21 33 -21 1046 -21 1013 0 1019 0 1046 21 53 39 69 71 69 134 0 63 -16 95 -69 134 -27 20 -41 21 -457 24 l-429 3 0 239 0 240 828 0 c899 0 881 -1 994 56 71 36 159 123 197 193 64 121 61 49 61 1431 0 1095 -2 1263 -15 1315 -45 172 -179 305 -352 350 -85 22 -3669 21 -3752 -1z m3725 -330 c15 -11 37 -33 48 -48 21 -27 21 -31 21 -1285 l0 -1258 -29 -37 c-54 -71 95 -66 -1900 -64 l-1805 3 -27 21 c-15 11 -37 33 -48 48 -21 27 -21 33 -24 1259 -1 678 0 1246 3 1264 7 40 49 91 90 109 25 11 350 13 1837 11 l1807 -2 27 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.7885966db574b527dd09a294ec0a8a30.svg";
export { ForwardRef as ReactComponent };